import { observer } from "mobx-react";
import { Box, Divider, VStack } from "@chakra-ui/react";
import { UserAccountStore } from "store/UserAccounts/UserAccount/UserAccount.store";
import React, { FC, MutableRefObject } from "react";
import { BlacklistedEmails } from "./BlacklistedEmails/BlacklistedEmails";
import { IvtConfig } from "./IvtConfig/IvtConfig";
import { LeadIconsConfig } from "./LeadIconsConfig/LeadIconsConfig";

interface IProps {
  accountStore: UserAccountStore;
  containerRef: MutableRefObject<HTMLDivElement | null>;
}

export const AccountLeadsConfig: FC<IProps> = observer(
  ({ accountStore, containerRef }) => {
    return (
      <Box position={"relative"} minHeight={"100%"} overflow={"hidden"} pr={1}>
        <VStack spacing={7} align={"stretch"} divider={<Divider />}>
          <IvtConfig accountStore={accountStore} />
          <BlacklistedEmails accountStore={accountStore} />
          <LeadIconsConfig accountStore={accountStore} />
        </VStack>
      </Box>
    );
  }
);
